import React from 'react';
import { useAxios } from '../../../hooks/useAxios';

export const useImageUpload = (options: { imageUploadUrl: string }) => {
  const { imageUploadUrl } = options;

  const axios = useAxios();

  const onImageUpload = React.useCallback(
    async (file: File) => {
      const formData = new FormData();
      formData.append('files', file);

      const response = await axios({
        url: imageUploadUrl, 
        method: 'POST',
        data: formData,
      });

      return response.data.url;
    },
    [imageUploadUrl, axios],
  );

  return onImageUpload;
};
